import { APP_TYPES } from '../constants';
import { BaseApplication } from './baseApplication';
import { ApplicationLifeCycle } from '../interface';

export class DialogApplication extends BaseApplication {

  public type: string = APP_TYPES.DIALOG;

  public open(): void {
    // TODO: It looks to me that a reset should only be done by the
    // close method, because the initial value is false which means that
    // this line is only necessary if someone removes the iframe without
    // using the close method. This looks like a bug. Maybe it has something
    // to do that we can only show one iframe at the same time, but if a new
    // dialog IAC use cases is called but a other dialog is still opened
    // the iframe from the dialog will removed without using the close
    // method. We have to check that.
    this.resetIacConnected();

    ApplicationLifeCycle.openDialog(this);
  }

  public close(): void {
    ApplicationLifeCycle.closeDialog(this);

    // Reset the IAC connection flag, because the target dialog app itself
    // can be opened more than once, but on each opening a new iframe is used.
    // And it took some time until the app is connected and we will than lose some IAC calls.
    this.resetIacConnected();
  }

  public isRunning(): boolean {
    return ApplicationLifeCycle.isDialogInitialized(this);
  }

  public isOnFocus(): boolean {
    return ApplicationLifeCycle.isDialogOnFocus(this);
  }

}
